<label [formGroup]="parentForm" [attr.aria-checked]="parentForm.value[controlName] === radioKey">
  <div
    class="flex relative regular-type radio-wrapper"
    [class.ps-small-t]="displayContainerStyles"
    [class.grey-600-text]="parentForm.get(controlName).disabled"
    [class.text-icon-disabled-text]="parentForm.get(controlName).disabled"
  >
    <input
      class="is-vishidden"
      role="radio"
      [class.sensitive]="isSensitive"
      [id]="controlName + '-' + radioKey"
      type="radio"
      [value]="radioKey"
      [attr.name]="controlName"
      [formControlName]="controlName"
      [name]="controlName"
    />
    <span
      aria-hidden="true"
      class="flex flex--align-start"
      [class.nordic-blue-900-text]="!parentForm.get(controlName).disabled"
      [class.text-icon-primary]="!parentForm.get(controlName).disabled"
      [class.grey-200-text]="parentForm.get(controlName).disabled"
      [class.text-icon-disabled-text]="parentForm.get(controlName).disabled"
    >
      @if (parentForm.value[controlName] === radioKey) {
        <fcom-icon
          class="radio-icon icon-small"
          [dataTestId]="'icon-' + SvgLibraryIcon.RADIO_SELECTED"
          [name]="SvgLibraryIcon.RADIO_SELECTED"
        />
      } @else {
        <fcom-icon
          class="radio-icon icon-small"
          [dataTestId]="'icon-' + SvgLibraryIcon.RADIO_UNSELECTED"
          [name]="SvgLibraryIcon.RADIO_UNSELECTED"
        />
      }
    </span>
    @if (!description) {
      <span class="label font-body-1 ms-xsmall-l font-body-medium">
        {{ translationPrefix + '.' + radioKey | finLocalization }}
      </span>
    }
    @if (description) {
      <div class="label font-body-1 ps-xsmall-l inline fill font-body-medium">
        <div class="medium-type">{{ descriptionTitle }}</div>
        <div class="font-body-2 grey-700-text text-icon-secondary font-body-small">{{ descriptionText }}</div>
        <div class="nordic-blue-900-text text-icon-primary"><ng-content /></div>
      </div>
    }
  </div>
</label>
